// Child-area color palettes. Parents approve a subset; the child picks one.
// className "" = the standard .theme-child tokens (Warm Default).
// Themes ONLY change color tokens + animations — never safety or layout.
export const CHILD_THEMES = [
  { key: "warm", name: "Warm Default", className: "",
    swatch: ["#BEE9FB", "#F59E0B", "#3B82F6"],
    description: "The friendly standard look — sunny and bright." },
  { key: "calm", name: "Calm Blue", className: "child-theme-calm",
    swatch: ["#E8F1FA", "#2570C4", "#3E8E9E"],
    description: "Soft blues for quiet, focused play." },
  { key: "playful", name: "Playful Color", className: "child-theme-playful",
    swatch: ["#FDF3C7", "#E14D8F", "#7C4DD8"],
    description: "Bright colors with bouncy buttons and icons." },
  { key: "contrast", name: "High Contrast", className: "child-theme-contrast",
    swatch: ["#FFFFFF", "#000000", "#1D24B8"],
    description: "Bold black-on-white for easier reading." },
  { key: "dark", name: "Dark Mode", className: "child-theme-dark",
    swatch: ["#1B2233", "#F5B840", "#7FA9F0"],
    description: "Gentle on the eyes in the evening." },
  { key: "festive", name: "Winter Festive", className: "child-theme-festive",
    seasonal: true, returnsIn: "December",
    swatch: ["#E2F2E6", "#C0392B", "#1F7A44"],
    description: "A limited-time holiday look for festive play sessions." },
  { key: "blossom", name: "Spring Blossom", className: "child-theme-blossom",
    seasonal: true, returnsIn: "March",
    swatch: ["#FDECF3", "#D9538A", "#3E8E52"],
    description: "Pink petals and fresh spring greens — March through May." },
  { key: "beach", name: "Summer Beach", className: "child-theme-beach",
    seasonal: true, returnsIn: "June",
    swatch: ["#FFF4DD", "#DE7A21", "#1B8A9E"],
    description: "Sunny sand and sea blues — June through August." },
];
